import { StripePaymentElementOptions } from '@stripe/stripe-js';

type Options = {
    isSingleForm: boolean;
};

export function getPaymentElementOptions(options: Options): StripePaymentElementOptions {
    const { isSingleForm } = options;

    const paymentElementOptions: StripePaymentElementOptions = {
        wallets: {
            applePay: 'never',
            googlePay: 'never',
        },
        layout: {
            type: isSingleForm ? 'tabs' : 'accordion',
            // prevent the warning about "radios" property existing for "tabs" layout
            ...(!isSingleForm ? { radios: true } : null),
        },
        terms: {
            card: 'never',
        },
        fields: {
            billingDetails: {
                email: 'never',
                address: {
                    country: 'never',
                },
            },
        },
    };

    return paymentElementOptions;
}
